import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CommonUtil, WijimoUtil } from 'src/app/utils';
import { CollectionView } from '@grapecity/wijmo';
import * as wjcGrid from "@grapecity/wijmo.grid";
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { CommonService, PatPreDrugModalService } from 'src/app/services';
import { CommonStore } from 'src/app/store';
import { v4 as uuid } from 'uuid';
@Component({
  selector: 'app-common-inbound-match-details',
  templateUrl: './common-inbound-match-details.component.html',
  standalone: false
})
export class CommonInboundMatchDetailsComponent implements OnInit {
  @Output() IsPopUpClosed = new EventEmitter<any>();
  unsubscribe$: Subject<void> = new Subject();
  @Input() MatchData;
  @Input() InboundDetails;  
  patientWJ: CollectionView;
  patientList: any[];
  patientwjHeaders: any;
  prescriberWJ: CollectionView;
  prescriberList: any[];
  prescriberwjHeaders: any;
  insuranceWJ: CollectionView;
  insuranceList: any[];
  insurancewjHeaders: any;
  pharmacyWJ: CollectionView;
  pharmacyList: any[];
  pharmacywjHeaders: any;
  isPatientDataExists : boolean;
  loading: boolean;
  progressValue: number;
  noContact:boolean;
  patientHistRef: any;
  inBoundDataStore: boolean = true;
  popupId = uuid();
  @HostListener("window:keydown", ["$event"])
    keyEventAlt(event: KeyboardEvent) {
      const topPopup = this._commonUtil.getTopPopup();
      if (topPopup === this.popupId) {
          if (event.which === 27) {
              this.cancelModal();
              event.preventDefault();
          }
        }
  }
  constructor(private _wijimoUtils: WijimoUtil, public _storageService: StorageService, private _commonUtil: CommonUtil, private _patPreDrugService: PatPreDrugModalService, private _cmnSvc: CommonService, private _commonStore: CommonStore,
  
  ) {}

  ngOnInit() {
    this.patchDefaultValHeaders();
    this._commonUtil.open(this.popupId);
    this._wijimoUtils.wjSavedData$.pipe(takeUntil(this.unsubscribe$)).subscribe(w => {
        if (w && w["WijmoKey"] && (w["WijmoKey"] === "patientMatchListWj" || w["WijmoKey"] === "prescriberMatchListWj" || w["WijmoKey"] === "insuracneMatchListWj" || w["WijmoKey"] === "extPharmacyMatchListWj")) {
          this.patchDefaultValHeaders();
        }
    });
    if(this.MatchData?.entityDetails?.length) {
        this.patientList = this.MatchData?.entityDetails.filter(item1 => item1?.typeId === 1);
        this.prescriberList = this.MatchData?.entityDetails.filter(item2 => item2?.typeId === 2);
        this.insuranceList = this.MatchData?.entityDetails.filter(item2 => item2?.typeId === 3);
        this.pharmacyList = this.MatchData?.entityDetails.filter(item2 => item2?.typeId === 4);
        if(this.patientList?.length || this.prescriberList?.length || this.insuranceList?.length || this.pharmacyList?.length) { 
          this.noContact = false;
          this.generatePatPresInsPharWijGrid();
        }
    } else {
      this.noContact = true;
    }

    this._cmnSvc._miniMizeScreen$.subscribe(val => {
          if(val && !val.miniScreen && this.patientHistRef) {
              this.patientHistRef.close();
          }
      });
    
    this._commonStore._signlrInboundData$.pipe(takeUntil(this.unsubscribe$)).subscribe(val => {
        if(val) {
            const storedValue = localStorage.getItem("IvrGUIDDetails");
            let ivrDetails = this._cmnSvc.getIvrGUIDDetails(storedValue, this._cmnSvc.DecryptData(localStorage.getItem('SfaxEncryptionVector')));
            if(ivrDetails && (+ivrDetails?.extension === +val?.extension)) {
                if(val?.call_state === "hangup" && val?.direction === "inbound") {
                    this.inBoundDataStore = false;
                }
            }
        }
    });
  }

  async patchDefaultValHeaders() {
    const storedpatWJ = await this._wijimoUtils.getWJSavedData("patientMatchListWj");
    this.patientwjHeaders = await this._wijimoUtils.patchDefHeader("patientMatchListWj", storedpatWJ);
    const storedprecWJ = await this._wijimoUtils.getWJSavedData("prescriberMatchListWj");
    this.prescriberwjHeaders = await this._wijimoUtils.patchDefHeader("prescriberMatchListWj", storedprecWJ);
    const storedinsWJ = await this._wijimoUtils.getWJSavedData("insuracneMatchListWj");
    this.insurancewjHeaders = await this._wijimoUtils.patchDefHeader("insuracneMatchListWj", storedinsWJ);
    const storedphrWJ = await this._wijimoUtils.getWJSavedData("extPharmacyMatchListWj");
    this.pharmacywjHeaders = await this._wijimoUtils.patchDefHeader("extPharmacyMatchListWj", storedphrWJ);
  }

  cancelModal() {
    this._cmnSvc._isCallOngoing$.next(false);
    this.IsPopUpClosed.emit(false);
    const storedValue = localStorage.getItem("IvrGUIDDetails");
    let ivrDetails = this._cmnSvc.getIvrGUIDDetails(storedValue, this._cmnSvc.DecryptData(localStorage.getItem('SfaxEncryptionVector')));
    if(this.inBoundDataStore && ivrDetails && ivrDetails?.vendorId === 1) {
      this._cmnSvc._isCallOngoing$.next(true);
      this._cmnSvc._storeCallLogDetailsForInbound$.next(this.InboundDetails);
    };
  }

  generatePatPresInsPharWijGrid() {
    if(this.patientList?.length) {
      this.patientWJ = new CollectionView(this.patientList?.map((pat: any, i) => {
        const k = {};
        k["RowId"] = i;
        k["Patient Name"] = pat?.name + " <label style='color: #2B7FFF;'>" + (pat?.preferredContact ? ' ('+pat?.preferredContact?.contactType+')' : '') + "</label>";
        k["patientName"] = pat?.name;
        k["DOB"] = pat?.dateOfBirth ? pat?.dateOfBirth : '--';
        k["Gender"] = pat?.gender ? pat?.gender : '--';
        k["Phone#"] = this.MatchData?.phoneNumber && this.MatchData?.phoneNumber !== "###" ? this._commonUtil.getPhoneFormat(this.MatchData?.phoneNumber.trim()) : "--";
        k["mobile"] = this.MatchData?.phoneNumber;
        k["Address"] = pat?.address ? pat?.address : '--';
        k["Id"] = pat?.id;
        k["typeId"] = pat?.typeId;
        return k;
      }))
    }
    if(this.prescriberList?.length) {
      this.prescriberWJ = new CollectionView(this.prescriberList?.map((pres: any, i) => {
        const k = {};
        k["RowId"] = i;
        k["Prescriber Name"] = pres?.name
        k["NPI"] = pres?.npi ? pres?.npi : '--';
        k["Address"] = pres?.address ? pres?.address : '--';
        k["Phone#"] = this.MatchData?.phoneNumber && this.MatchData?.phoneNumber !== "###" ? this._commonUtil.getPhoneFormat(this.MatchData?.phoneNumber.trim()) : "--";
        k["mobile"] = this.MatchData?.phoneNumber;
        k["Id"] = pres?.id;
        k["typeId"] = pres?.typeId;
        return k;
      }))
    }
    if(this.insuranceList?.length) {
      this.insuranceWJ = new CollectionView(this.insuranceList?.map((ins: any, i) => {
        const k = {};
        k["RowId"] = i;
        k["Insurance Name"] = ins?.name
        k["Insurance Code"] = ins?.code ? ins?.code : '--';
        k["Payor"] = ins?.payor ? ins?.payor : '--';
        k["BIN/PCN"] = (ins?.bin ? ins?.bin : '--') +'/'+(ins?.pcn ? ins?.pcn : '--');
        k["Phone#"] = this.MatchData?.phoneNumber && this.MatchData?.phoneNumber !== "###" ? this._commonUtil.getPhoneFormat(this.MatchData?.phoneNumber.trim()) : "--";
        k["mobile"] = this.MatchData?.phoneNumber;
        k["Id"] = ins?.id;
        k["typeId"] = ins?.typeId;
        return k;
      }))
    }
    if(this.pharmacyList?.length) {
      this.pharmacyWJ = new CollectionView(this.pharmacyList?.map((phr: any, i) => {
        const k = {};
        k["RowId"] = i;
        k["Other Pharmacy Name"] = phr?.name
        k["NPI#"] = phr?.npi ? phr?.npi : '--';
        k["Address"] = phr?.address ? phr?.address : '--';
        k["eRx Xfer Avlbl"] = k["xferavl"] = phr?.xferServiceLevel;
        k["Phone#"] = this.MatchData?.phoneNumber && this.MatchData?.phoneNumber !== "###" ? this._commonUtil.getPhoneFormat(this.MatchData?.phoneNumber.trim()) : "--";
        k["mobile"] = this.MatchData?.phoneNumber;
        k["Id"] = phr?.id;
        k["typeId"] = phr?.typeId;
        return k;
      }))
    }
    
}
  
itemFormatter = (panel, r, c, cell) => {
    const row = panel.rows[r];
    if (row.dataItem) {
        cell.style.color = "#000";
        cell.style.background = "#FFF";
        cell.style.fontWeight = "400";
    }
    if (panel.cellType == wjcGrid.CellType.ColumnHeader && r == 0) {
        cell.style.backgroundColor = "#EAEAEA";
        cell.style.color = "#000";
        cell.style.lineHeight = "24px";
        cell.style.fontWeight = "700"
    }
  }

patientHist(pat) {
  if(pat?.Id) {
    this._cmnSvc._isCallOngoing$.next(true);
    this._patPreDrugService._patPreDrugModal$.next("patHist");
      this.patientHistRef = this._patPreDrugService.modalInstanceRef;
      this.patientHistRef.componentInstance.patientID = +pat?.Id;
      this.patientHistRef.componentInstance.popUpOpenFr = "IVR";
      this.patientHistRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe(closed => {
        if(this.patientHistRef) {
          this.patientHistRef.close();
        }
          this._patPreDrugService._patPreDrugModal$.next(null);
        });
        let reqobj = {
            logDetails: { patient : {name : pat?.patientName, id : pat?.Id, dob : pat?.DOB, gender : pat?.Gender, addressLine1: pat?.Address, phoneNumber:pat?.mobile}, callDetails: { mode: 'IVR', direction: 'Inbound', extension: this.InboundDetails?.extension,
            forpatient:  pat?.patientName, phoneNumber: this.MatchData?.phoneNumber, call_uuid:this.InboundDetails?.call_uuid }, recipient: { entityType: 1, entityId: pat?.Id, entityName: pat?.patientName } }, callLogId:this.InboundDetails?.callLogId, uniqueId: uuid()
          }
        this._cmnSvc._storeCallLogDetails$.next(reqobj); 
  }
  
}

onRowDoubleClick(grid,e) {
   var hti;
    hti = grid.hitTest(e);
    if (hti && hti.row >=0 && grid.selectedRows && grid.selectedRows.length && grid.selectedRows[0].dataItem && hti.cellType === 1) {
      let pat = grid.selectedRows[0].dataItem;
      let patDetails;
      patDetails = {PatientName : pat?.patientName, patientid : pat?.Id, dob : pat?.DOB, gender : pat?.Gender, address1: pat?.Address, mobile:pat?.mobile}
      this._cmnSvc._isCallOngoing$.next(true);
      let checkCallLogData = this._cmnSvc._storeCallLogDetails$.getValue();
      if(checkCallLogData && checkCallLogData?.logDetails?.callDetails?.phoneNumber === patDetails?.mobile) this._cmnSvc._miniMizeScreen$.next({ details: checkCallLogData, miniScreen: false });
      this._commonUtil.openCallLogPopup(pat?.mobile,patDetails,'Patient','','','',true,this.InboundDetails);      
    }
}

openCommsPopup(data) {
  let details, entityType;
  switch(data?.typeId) {
        case 2:
          details = { PrescriberName : data["Prescriber Name"], PrescriberId : data?.Id };
          entityType = 'Prescriber';
        break;
        case 3:
          details = { PlanCode :data["Insurance Code"], Id : data?.Id, InsuName: data["Insurance Name"] };
          entityType = 'Insurance';
        break;
        case 4:
          details = { PharmName : data["Other Pharmacy Name"], PharmId : data["Id"] };
          entityType = 'Pharmacy';
        break; 
      }
    this._cmnSvc._isCallOngoing$.next(true);
    let checkCallLogData = this._cmnSvc._storeCallLogDetails$.getValue();
    if((checkCallLogData && checkCallLogData?.logDetails?.callDetails?.phoneNumber === data?.mobile)) this._cmnSvc._miniMizeScreen$.next({ details: checkCallLogData, miniScreen: false });
    this._commonUtil.openCallLogPopup(data?.mobile,details,entityType,'','','',true,this.InboundDetails); 
}

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this._commonUtil.close(this.popupId);
    this._storageService.getWijmoGridDataInSession(this.patientwjHeaders,"patientMatchListWj",'1');
    this._storageService.getWijmoGridDataInSession(this.prescriberwjHeaders,"prescriberMatchListWj",'2');
    this._storageService.getWijmoGridDataInSession(this.insurancewjHeaders,"insuracneMatchListWj",'3');
    this._storageService.getWijmoGridDataInSession(this.pharmacywjHeaders,"extPharmacyMatchListWj",'4');
  }

}
